import regularAppService from "./regularAppService";

export const getPeoplePage = async ({ page, limit, search, sortBy = "updatedAt", sortOrder = "desc" } = {}) => {
  const isValidSearch = typeof search === "string" && search.trim().length > 0;
  const result = await regularAppService.getPaginated({
    collection: "peoples",
    ...(Number.isFinite(Number(page)) ? { page: Number(page) } : {}),
    ...(Number.isFinite(Number(limit)) ? { limit: Number(limit) } : {}),
    ...(isValidSearch ? { search } : {}),
    sortBy,
    sortOrder,
  });
  return result;
};

export const updatePeople = async ({
  peopleId,
  name,
  password,
  email,
  phone,
  department,
  jobTitle,
  startDate,
  address,
  emergencyContact,
  status,
  roleId,
}) => {
  const updatedPerson = {
    _id: peopleId,
    name,
    password,
    email,
    phone,
    department,
    jobTitle,
    startDate,
    address,
    emergencyContact,
    status,
    ...(roleId ? { roleId } : {}),
    updatedAt: new Date().toISOString(),
  };

  const result = await regularAppService.upsert({ collection: "peoples", data: updatedPerson });
  return result;
};

export const createPeople = async ({
  name,
  password,
  userId,
  image,
  email,
  phone,
  department,
  jobTitle,
  startDate,
  address,
  emergencyContact,
  status,
  roleId,
}) => {
  
  const newPerson = {
    name,
    password,
    userId,
    image,
    email,
    phone,
    department,
    jobTitle,
    startDate,
    address,
    emergencyContact,
    status,
    ...(roleId ? { roleId } : {}),
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  };

  
  const result = await regularAppService.upsert({ collection: "peoples", data: newPerson });
  
  
  return result;
};

export const getPeople = async () => {
  const page = await regularAppService.getPaginated({ collection: "peoples" });
  return Array.isArray(page.items) ? page.items : [];
};

export const deletePerson = async (personId) => {
  const people = await getPeople({});
  const person = people.find((p) => p._id === personId);

  if (!person) {
    throw new Error("Person not found");
  }

  const deletedPerson = {
    ...person,
    deleted: true,
    updatedAt: new Date().toISOString(),
  };

  const result = await regularAppService.upsert({ collection: "peoples", data: deletedPerson });
  return result;
};

export const searchPeople = async ({ search = "" }) => {
  const isValid = typeof search === "string" && search.trim().length > 0;
  const pageResult = await regularAppService.getPaginated({
    collection: "peoples",
    ...(isValid ? { search } : {}),
  });
  return pageResult.items || [];
};

// Method to force a sync with the server
export const syncPeople = async () => {
  return await getPeople({});
};

// Debugging function to reset and check people data
export const debugPeople = async () => {
  return [];
};
